<div class="app-container">
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  <form [formGroup]="userForm" (ngSubmit)="isCreating ? createUser() : updateUser()" *ngIf="user">
    <page-header
      [icon]="'far-user-cog'"
      [title]="isCreating ? 'user.new' : isUserProfile ? 'user.profile' : 'user.edit'"
      [appendNoTranslationTitlePart]="!isCreating && user ? user.email : ''"
    >
      <ng-container class="header-button" *ngIf="user">
        <btn
          [btnType]="'submit'"
          [classes]="['btn-first', 'float-right']"
          [btnDisabled]="loading"
          [icon]="'far-check'"
          [label]="'save'"
          [title]="'save' | translate"
          [isLoading]="loading"
          spinnerClassesString="spinner-white"
          data-cy="change-info"
        ></btn>
        <btn
          *ngIf="!isCreating && user?.deletable"
          [btnType]="'button'"
          [label]="'delete'"
          [title]="'delete' | translate"
          [classes]="['btn-first-red', 'float-right', 'mr-2']"
          [icon]="'far-trash-alt'"
          (onEvent)="deleteUser()"
          data-cy="delete-depot"
        ></btn>
        <app-modal-change-pass
          *ngIf="!isCreating && (isUserProfile || isUserPermitted(loggedInUser))"
          [userProfile]="user"
        ></app-modal-change-pass>
      </ng-container>
      <ng-container class="back-button">
        <btn
          [label]="'back'"
          [title]="'back' | translate"
          [isBackButton]="true"
          [classes]="['btn-third', 'float-right', 'mr-2']"
          [icon]="'far-arrow-left'"
          (onEvent)="triggerBackBtn()"
        ></btn>
      </ng-container>
    </page-header>

    <section class="content">
      <div class="card">
        <div class="row">
          <div class="col-sm-6">
            <form-row-select
              [label]="'settings.locale'"
              [options]="availableLanguages"
              [formGroup]="userForm"
              formControlName="locale"
              [dataCyAttribute]="'locale'"
            >
            </form-row-select>
            <form-row-input
              [label]="'firstname'"
              [formGroup]="userForm"
              formControlName="firstName"
              [icon]="'far-user'"
              [required]="userForm.get('firstName').errors !== null && userForm.get('firstName').errors.required"
              [requiredCssClass]="submitted && formControls.firstName.errors"
              data-cy="first-name"
            ></form-row-input>
            <form-row-input
              [label]="'lastname'"
              [formGroup]="userForm"
              formControlName="lastName"
              [required]="userForm.get('lastName').errors !== null && userForm.get('lastName').errors.required"
              [requiredCssClass]="submitted && formControls.lastName.errors"
              [icon]="'far-list'"
              data-cy="last-name"
            ></form-row-input>
            <form-row-input
              [label]="'phone'"
              [icon]="'far-phone'"
              [formGroup]="userForm"
              formControlName="phone"
              data-cy="phone"
            ></form-row-input>
            <form-row-input
              [label]="'email'"
              [icon]="'far-envelope'"
              [formGroup]="userForm"
              formControlName="email"
              [inputType]="'email'"
              [required]="userForm.get('email').errors !== null && userForm.get('email').errors.required"
              [requiredCssClass]="submitted && formControls.email.errors"
              data-cy="email"
            ></form-row-input>
            <!--              <form-row-input-->
            <!--                *ngIf="isCreating"-->
            <!--                [label]="'password'"-->
            <!--                [icon]="'far-lock'"-->
            <!--                [formGroup]="userForm"-->
            <!--                formControlName="plainPassword"-->
            <!--                [required]="userForm.get('plainPassword').errors !== null && userForm.get('plainPassword').errors.required"-->
            <!--                [requiredCssClass]="submitted && formControls.plainPassword.errors"-->
            <!--                [inputType]="'password'"-->
            <!--                data-cy="password"-->
            <!--              ></form-row-input>-->
            <form-row-password
              *ngIf="isCreating"
              [isSingleInput]="true"
              [label]="'password'"
              (validityChange)="isPasswordValid = $event"
              (modelChange)="password = $event"
            ></form-row-password>
            <btn
              *ngIf="isUserProfile"
              [title]="'cookies.dialog'"
              [label]="'cookies.dialog'"
              (onEvent)="showCookieConsentDialog()"
            ></btn>
          </div>
          <div
            class="col-sm-3"
            *ngIf="isCreating || (!isCreating && !isUserProfile) || (!isCreating && isUserProfile && isUserPermitted())"
          >
            <label class="mb-0">{{ 'user.associated-devices' | translate }}</label>
            <ng-container class="mb-2" *ngFor="let institution of institutions">
              <div class="mb-2">
                <form-row-checkbox
                  [label]="institution.name"
                  [cursorPointer]="true"
                  [model]="hasUserInstitution(user, institution)"
                  (modelChange)="updateInstitution(institution, $event)"
                ></form-row-checkbox>
                <label *ngIf="institution.checkouts?.length" class="mb-0 padding-left"
                  >{{ 'checkout' | translate }}:</label
                >
                <div class="mb-0 padding-left">
                  <ng-template ngFor let-checkout [ngForOf]="institution.checkouts">
                    <ng-template [ngIf]="checkout.name !== 'MASTER'">
                      <form-row-checkbox
                        [label]="checkout.name"
                        [cursorPointer]="true"
                        [model]="hasUserCheckout(user, checkout)"
                        (modelChange)="updateCheckout(checkout, $event)"
                      >
                      </form-row-checkbox>
                    </ng-template>
                  </ng-template>
                </div>
                <label *ngIf="institution.depots?.length > 0" class="mb-0 padding-left">{{
                  'user.depots' | translate
                }}</label>
                <div class="mb-0 padding-left">
                  <ng-template ngFor let-depot [ngForOf]="institution.depots">
                    <ng-template [ngIf]="depot.name !== 'MASTER'">
                      <form-row-checkbox
                        [label]="depot.name"
                        [cursorPointer]="true"
                        [model]="hasUserDepot(user, depot)"
                        (modelChange)="updateDepot(depot, $event)"
                      >
                      </form-row-checkbox>
                    </ng-template>
                  </ng-template>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="(!institutions?.length || institutions?.length === 0) && depots?.length > 0">
              <label class="mb-0 padding-left">{{ 'user.depots' | translate }}</label>
              <div class="mb-0 padding-left" *ngFor="let depot of depots">
                <form-row-checkbox
                  [label]="depot.name"
                  [cursorPointer]="true"
                  [model]="hasUserDepot(user, depot)"
                  (modelChange)="updateDepot(depot, $event)"
                >
                </form-row-checkbox>
              </div>
            </ng-container>
          </div>

          <div
            class="col-sm-3"
            *ngIf="isCreating || (!isCreating && !isUserProfile) || (!isCreating && isUserProfile && isUserPermitted())"
          >
            <label class="mb-0">{{ 'groups' | translate }}:</label>
            <div class="mb-2" *ngFor="let group of groups">
              <form-row-checkbox
                [inputDisabled]="group.name === 'Admin' && !isUserAdmin"
                [label]="'userGroup.' + group.externalId"
                [cursorPointer]="true"
                [model]="isUserInGroup(user, group)"
                (modelChange)="updateGroup(group, $event)"
              ></form-row-checkbox>
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>
</div>
